import { Button, ButtonVariant, NavigationBarButton } from "@merge-api/merge-javascript-shared";
import { useHistory, useLocation } from "react-router-dom";
import { BlueprintVersionPublishState } from "../../../models/Blueprints";
import { navigateToBlueprintEditor } from "../../../router/RouterUtils";
import useBlueprintContext from "../../blueprint-editor/context/useBlueprintContext";
import { IntegrationEditorLeftPanelVerticalTab } from "./IntegrationEditorLeftPanel";

type Props = {
  verticalTabs: IntegrationEditorLeftPanelVerticalTab[];
};

const IntegrationEditorLeftPanelVerticalNavbar = ({ verticalTabs }: Props) => {
  const { blueprint, blueprintVersions } = useBlueprintContext();
  const history = useHistory();
  const location = useLocation();
  const integrationID = blueprint.integration.id;
  const currentVersionID = blueprint.version.id;

  const latestPublishedVersion = blueprintVersions.find(
    (bp) => bp.publish_state === BlueprintVersionPublishState.Published
  );

  function viewBlueprintVersion(blueprint_version_id: string) {
    navigateToBlueprintEditor(history, integrationID, blueprint_version_id);
  }

  return (
    <div className="border-t border-b border-gray-10 px-3 flex flex-col">
      <ul className="flex flex-col py-6 gap-y-2">
        {verticalTabs.map(({ href, Icon, title }) => {
          const isSelected = location.pathname === href;
          return (
            <NavigationBarButton
              key={title}
              onClick={() => history.push(href)}
              selected={isSelected}
            >
              <div className="flex flex-row items-center gap-x-2">
                <Icon size={16} />
                <div>{title}</div>
              </div>
            </NavigationBarButton>
          );
        })}
      </ul>
      {latestPublishedVersion && currentVersionID !== latestPublishedVersion.id && (
        <Button
          variant={ButtonVariant.PrimaryGray}
          className="mb-3"
          fullWidth
          onClick={() => viewBlueprintVersion(latestPublishedVersion.id!)}
        >
          Go to latest published version
        </Button>
      )}
    </div>
  );
};

export default IntegrationEditorLeftPanelVerticalNavbar;
